import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as wordpressVersionAction from '../actions/website-wp-version.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, switchMap} from 'rxjs/operators';
import {LoadWordpressVersion} from "../actions";
import {ProductService} from "../../websites/website/product.service";
import {LOAD_WP_VERSION} from "../actions/website-wp-version.action";

@Injectable()
export class WordpressWPVersionEffect {

  loadWordpressVersion$ = createEffect(() => this._actions$.pipe(
    ofType(LOAD_WP_VERSION),
    switchMap((action: LoadWordpressVersion) => {
      return  this._productService.getWordpressVersion(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new wordpressVersionAction.LoadWordpressVersionSuccess({
                websiteId: action.payload,
                entities: response.data.offers[0].version
              });
            }
            return new wordpressVersionAction.LoadWordpressVersionFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _productService: ProductService
  ) {
  }
}
